import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import bodyLeftBg from '../../../images/Rectangle 302.png';
import ContactForm from '../../Shared/ContactForm/ContactForm';
import './ContactUs.css';

const connectTextBg = {
    backgroundImage: `url(${bodyLeftBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '30% 80%'
}

const ContactUs = () => {
    return (
        <>
            <Box sx={{ pb: 10, pt: 3 }} id="form-bg">
                <Box style={connectTextBg} sx={{ pb: 4 }}>
                    <Container>
                        <Box id="banner-textBg" sx={{ textAlign: 'left' }}>
                            <Typography variant="h3" id="connect-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600, pl: 4, py: 4 }}>
                                Let's Connect
                            </Typography>
                        </Box>
                    </Container>
                </Box>
                <Box sx={{ pb: 10, pt: 1 }}>
                    <ContactForm />
                </Box>
            </Box>
        </>
    );
};

export default ContactUs;